import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Token yönetimi
const getToken = () => localStorage.getItem('authToken');
const setToken = (token) => localStorage.setItem('authToken', token);
const removeToken = () => localStorage.removeItem('authToken');

// Axios instance with auth header
const authAxios = axios.create();

authAxios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401 hatasında token temizle ve login'e yönlendir
authAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeToken();
      localStorage.removeItem('currentUser');
      // Sayfa yeniden yüklendiğinde login'e yönlendirilecek
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const api = {
  // Token yönetimi
  setAuthToken: setToken,
  removeAuthToken: removeToken,
  getAuthToken: getToken,
  
  // Auth
  login: (kullaniciId, sifre) => axios.post(`${API}/login`, { kullaniciId, sifre }),
  verifyToken: () => authAxios.get(`${API}/verify-token`),
  sifreDegistir: (eskiSifre, yeniSifre) => authAxios.post(`${API}/sifre-degistir`, { eskiSifre, yeniSifre }),
  adminSifreSifirla: (hedefKullaniciId, yeniSifre) => authAxios.post(`${API}/admin/sifre-sifirla`, { hedefKullaniciId, yeniSifre }),
  
  // Kullanıcılar
  getKullanicilar: () => axios.get(`${API}/kullanicilar`),
  
  // Şubeler
  getSubeler: () => axios.get(`${API}/subeler`),
  
  // Bankalar
  getBankalar: (tur) => axios.get(`${API}/bankalar`, { params: { tur } }),
  createBanka: (data) => authAxios.post(`${API}/bankalar`, data),
  updateBanka: (id, data) => authAxios.put(`${API}/bankalar/${id}`, data),
  
  // Gün Sonu Kasa
  getGunSonu: (params) => authAxios.get(`${API}/gunsonu`, { params }),
  checkBugunKayit: (subeId) => authAxios.get(`${API}/gunsonu/bugun/${subeId}`),
  checkTarihKayit: (subeId, tarih) => authAxios.get(`${API}/gunsonu/tarih/${subeId}/${tarih}`),
  createGunSonu: (data) => authAxios.post(`${API}/gunsonu`, data),
  
  // Dashboard
  getBugunDashboard: () => authAxios.get(`${API}/dashboard/bugun`),
  getAylikDashboard: () => authAxios.get(`${API}/dashboard/aylik`),
  getBankaDashboard: () => authAxios.get(`${API}/dashboard/bankalar`),
  
  // Krediler
  getKrediler: (params) => authAxios.get(`${API}/krediler`, { params }),
  createKredi: (data) => authAxios.post(`${API}/krediler`, data),
  updateKredi: (id, data) => authAxios.put(`${API}/krediler/${id}`, data),
  deleteKredi: (id, silenKullaniciId) => authAxios.delete(`${API}/krediler/${id}`, { params: { silenKullaniciId } }),
  geriYukleKredi: (id) => authAxios.put(`${API}/krediler/${id}/geri-yukle`),
  getVadesiYaklasanTaksitler: () => authAxios.get(`${API}/taksitler/vadesi-yaklasan`),
  odeTaksit: (id) => authAxios.put(`${API}/taksitler/${id}/ode`),
  
  // Raporlar
  getAylikRapor: (params) => authAxios.get(`${API}/raporlar/aylik`, { params }),
  getBankaRapor: (params) => authAxios.get(`${API}/raporlar/banka`, { params }),
  
  // Çekler
  getCekler: (params) => authAxios.get(`${API}/cekler`, { params }),
  getCeklerOzet: (params) => authAxios.get(`${API}/cekler/ozet`, { params }),
  getVadesiYaklasanCekler: (gun) => authAxios.get(`${API}/cekler/vadesi-yaklasan`, { params: { gun } }),
  createCek: (data) => authAxios.post(`${API}/cekler`, data),
  tahsilEtCek: (id) => authAxios.put(`${API}/cekler/${id}/tahsil`),
  iadeEtCek: (id) => authAxios.put(`${API}/cekler/${id}/iade`),
  deleteCek: (id, silenKullaniciId) => authAxios.delete(`${API}/cekler/${id}`, { params: { silenKullaniciId } }),
  geriYukleCek: (id) => authAxios.put(`${API}/cekler/${id}/geri-yukle`),
  
  // Diğer Ödemeler
  getDigerOdemeler: (params) => authAxios.get(`${API}/diger-odemeler`, { params }),
  getVadesiYaklasanDigerOdemeler: (gun) => authAxios.get(`${API}/diger-odemeler/vadesi-yaklasan`, { params: { gun } }),
  createDigerOdeme: (data) => authAxios.post(`${API}/diger-odemeler`, data),
  odeDigerOdeme: (id) => authAxios.put(`${API}/diger-odemeler/${id}/ode`),
  geriAlDigerOdeme: (id) => authAxios.put(`${API}/diger-odemeler/${id}/geri-al`),
  deleteDigerOdeme: (id, silenKullaniciId) => authAxios.delete(`${API}/diger-odemeler/${id}`, { params: { silenKullaniciId } }),
  geriYukleDigerOdeme: (id) => authAxios.put(`${API}/diger-odemeler/${id}/geri-yukle`),
  
  // Tüm Ödemeler
  getTumOdemeler: (params) => authAxios.get(`${API}/tum-odemeler`, { params }),
  getTumOdemelerOzet: (params) => authAxios.get(`${API}/tum-odemeler/ozet`, { params }),
  
  // Kredi Kartları
  getKrediKartlari: (params) => authAxios.get(`${API}/kredi-kartlari`, { params }),
  getKrediKarti: (id) => authAxios.get(`${API}/kredi-kartlari/${id}`),
  createKrediKarti: (data) => authAxios.post(`${API}/kredi-kartlari`, data),
  updateKrediKarti: (id, data) => authAxios.put(`${API}/kredi-kartlari/${id}`, data),
  deleteKrediKarti: (id, kullaniciId) => authAxios.delete(`${API}/kredi-kartlari/${id}`, { params: { kullaniciId } }),
  geriYukleKrediKarti: (id) => authAxios.put(`${API}/kredi-kartlari/${id}/geri-yukle`),
  getKrediKartiOzet: () => authAxios.get(`${API}/kredi-kartlari/ozet/bekleyen`),
  uploadKrediKartiEkstre: (id, formData) => authAxios.post(`${API}/upload/kredi-karti/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Döviz Kurları
  getDovizKuru: () => axios.get(`${API}/doviz-kuru`),
  
  // LC Ödemeleri
  getLCOdemeler: (params) => authAxios.get(`${API}/lc-odemeler`, { params }),
  getLCOdeme: (id) => authAxios.get(`${API}/lc-odemeler/${id}`),
  createLCOdeme: (data) => authAxios.post(`${API}/lc-odemeler`, data),
  updateLCOdeme: (id, data) => authAxios.put(`${API}/lc-odemeler/${id}`, data),
  deleteLCOdeme: (id, kullaniciId) => authAxios.delete(`${API}/lc-odemeler/${id}`, { params: { kullaniciId } }),
  geriYukleLCOdeme: (id) => authAxios.put(`${API}/lc-odemeler/${id}/geri-yukle`),
  odeLCOdeme: (id) => authAxios.put(`${API}/lc-odemeler/${id}/ode`),
  getLCOzet: () => authAxios.get(`${API}/lc-odemeler/ozet/bekleyen`),
  uploadLCProforma: (id, formData) => authAxios.post(`${API}/upload/lc/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Faturalar
  getFaturalar: (params) => authAxios.get(`${API}/faturalar`, { params }),
  getFaturaOzet: (params) => authAxios.get(`${API}/faturalar/ozet`, { params }),
  syncFaturalar: (sirket, kaynak) => authAxios.post(`${API}/faturalar/sync`, { sirket, kaynak }),
  getFaturaContent: (uuid) => authAxios.get(`${API}/fatura-content/${uuid}`),
  getApiStatus: () => authAxios.get(`${API}/api-status`),
  karsilastirFaturalar: (data) => authAxios.post(`${API}/faturalar/karsilastir`, data),
  
  // Export
  exportTumOdemelerExcel: () => `${API}/export/tum-odemeler/excel`,
  exportTumOdemelerPdf: () => `${API}/export/tum-odemeler/pdf`,
  exportCeklerExcel: () => `${API}/export/cekler/excel`,
  exportDigerOdemelerExcel: () => `${API}/export/diger-odemeler/excel`,
  exportKredilerExcel: () => `${API}/export/krediler/excel`,
  
  // Kasa Defteri
  getKasaDefteri: (params) => authAxios.get(`${API}/kasa-defteri`, { params }),
  getKasaDefteriFis: (id) => authAxios.get(`${API}/kasa-defteri/${id}`),
  createKasaDefteriFis: (data) => authAxios.post(`${API}/kasa-defteri`, data),
  updateKasaDefteriFis: (id, kullaniciId, data) => authAxios.put(`${API}/kasa-defteri/${id}`, data, { params: { kullanici_id: kullaniciId } }),
  deleteKasaDefteriFis: (id, kullaniciId) => authAxios.delete(`${API}/kasa-defteri/${id}`, { params: { kullanici_id: kullaniciId } }),
  updateOdemeDurumu: (fisId, odemeIndex, kullaniciId, data) => authAxios.put(`${API}/kasa-defteri/${fisId}/odeme/${odemeIndex}/durum`, data, { params: { kullanici_id: kullaniciId } }),
  getKasaDefterRaporOzet: (params) => authAxios.get(`${API}/kasa-defteri/rapor/ozet`, { params }),
  getKasaDefteriBekleyenOdemeler: (sirket) => authAxios.get(`${API}/kasa-defteri/rapor/bekleyen-odemeler`, { params: { sirket } }),
  
  // Gider/Gelir ve Kasa Takip
  getGiderKategorileri: () => authAxios.get(`${API}/gider-kategorileri`),
  getKasaHareketleri: (params) => authAxios.get(`${API}/kasa-hareketleri`, { params }),
  createKasaHareketi: (data) => authAxios.post(`${API}/kasa-hareketleri`, data),
  updateKasaHareketi: (id, kullaniciId, data) => authAxios.put(`${API}/kasa-hareketleri/${id}`, data, { params: { kullanici_id: kullaniciId } }),
  deleteKasaHareketi: (id, kullaniciId) => authAxios.delete(`${API}/kasa-hareketleri/${id}`, { params: { kullanici_id: kullaniciId } }),
  getKasaDurumu: (sirket, tarih) => authAxios.get(`${API}/kasa-durumu`, { params: { sirket, tarih } }),
  getKasaGunlukRapor: (params) => authAxios.get(`${API}/kasa-gunluk-rapor`, { params }),
  getKrediKartiCekimler: (params) => authAxios.get(`${API}/kredi-karti-cekimler`, { params }),
  createKrediKartiCekim: (data) => authAxios.post(`${API}/kredi-karti-cekimler`, data),
  deleteKrediKartiCekim: (id) => authAxios.delete(`${API}/kredi-karti-cekimler/${id}`),
  
  // Netsis Kasa Sync
  syncKasaFromNetsis: (params) => authAxios.post(`${API}/kasa-hareketleri/sync-from-netsis`, null, { params }),
  
  // Miba Fatura Sayilari
  getMibaFaturaSayilari: (baslangic, bitis) => authAxios.get(`${API}/miba/fatura-sayilari`, { params: { baslangic, bitis } })
};
